export default __webpack_public_path__ + "static/media/upArrow.5db61d83.svg";